import api from "../proxy/config";
import axios from "./axiosConfig";

const authHeaders = () => ({
  headers: {
    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("token"))}`,
  },
});

const extractErrorMessage = (error, fallback) => {
  const backendError = error.response?.data;
  if (typeof backendError === "string") {
    return backendError;
  }
  if (backendError?.message) {
    return backendError.message;
  }
  if (backendError?.error) {
    return backendError.error;
  }
  return fallback;
};

export const getUsersByFilter = async (
  searchQuery,
  page,
  size,
  sortDirection = "desc",
  visibilita = null,
  ordinamentoCampo = "REGISTRAZIONE"
) => {
  try {
    const response = await axios.post(
      api.ricercaUsers,
      {
        searchFieldValue: searchQuery || "",
        limit: size,
        offset: page * size,
        ordinamento: sortDirection.toUpperCase(),
        ordinamentoCampo,
        visibilita,
      },
      authHeaders()
    );
    return response.data;
  } catch (error) {
    throw new Error(extractErrorMessage(error, "Errore nel recupero degli utenti"));
  }
};

export const utenteEliminaRipristina = async ({ userListId, ripristina }) => {
  try {
    const response = await axios.post(
      api.utenteElimina,
      { userListId, ripristina },
      authHeaders()
    );
    return response.data;
  } catch (error) {
    throw new Error(extractErrorMessage(error, "Errore durante l'operazione sull'utente"));
  }
};
 